import common from '../common'
const setTipMessage = (data) => {
    // 安卓
    if( !common?.isAndroid_ios() ) {
        if( window?.androidNative?.setTipMessage ) { 
            window.androidNative.setTipMessage(data)
        }
    }else {
        if( window?.webkit?.messageHandlers?.setTipMessage) {
            window?.webkit.messageHandlers.setTipMessage.postMessage(data)
        }
    }
}
export default setTipMessage